module.exports = "<svg viewBox=\"0 0 24 24\"><polygon id=\"Shape\" fill=\"#313D3E\" points=\"10.5060636 19.9155 12.4088613 17.9626642 7.66471461 13.2928984 21.3102222 13.2928984 21.3102222 10.5502731 7.66471461 10.5502731 12.4088613 5.86833577 10.5060636 3.9155 2.55677783 11.9148238\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./components/UI/Icon/images/arrow.svg
// module id = 741
// module chunks = 0